import {Injectable} from '@angular/core';


@Injectable()
export class StringService {

    /**
     * Complète une chaîne jusqu'à une taille donnée
     *
     * @example : console.log(strPad('1', 2, '0')); // output '01'
     */
    public static strPad(str: string, length: number, padString: string, padType: 'left' | 'right' = 'left'): string {
        if (padString.length === 0) {
            throw new Error('padString length is zero, cannot pad a string with nothing nom d\'une pipe');
        }

        const pad = padString.repeat(length);

        return padType === 'left' ? (pad + str).substr(-length) : (str + pad).substr(0, length);
    }

    public static compare(a: string, b: string): number {
        if (a === b) {
            return 0;
        }
        return StringService.slugify(a) > StringService.slugify(b) ? 1 : -1;
    }

    public static slugify(str: string): string {
        return StringService.stripAccents(str)
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
            .replace(/\s+/g, '-'); // separator
    }

    public static stripAccents(str: string): string {
        return str.normalize('NFD') // split an accented letter in the base letter and the accent
            .replace(/[\u0300-\u036f]/g, ''); // remove all previously split accents
    }

    public static stringIncludes(sourceString: string, searchString: string): boolean {
        return StringService.slugify(sourceString).includes(
            StringService.slugify(searchString)
        );
    }

    public stringIncludes(sourceString: string, searchString: string): boolean {
        return StringService.stringIncludes(sourceString, searchString);
    }

    public slugify(str: string): string {
        return StringService.slugify(str);
    }

    public stripAccents(str: string): string {
        return StringService.stripAccents(str);
    }

    public stringMatches(sourceString: string, searchString: string): number {
        const stringArray = searchString.split(' ');
        let score = 0;
        stringArray.forEach(stringPart => {
            if (stringPart.length) {
                if (this.stringIncludes(sourceString, stringPart)) {
                    score += 1;
                }
            }
        });
        return score;
    }

    public getInitials(fullName: string, capitalize: boolean = true): string {
        return StringService.getInitials(fullName);
    }

    static getInitials(fullName: string): string {
        return fullName.trim()
            .replace(/-/g, ' ')
            .split(/\s+/)
            .map(part => part.charAt(0).toUpperCase())
            .join('');
    }

    static compareStrings(a: string, b: string) {
        a = a.toLowerCase();
        b = b.toLowerCase();
        return (a < b ? -1 : (a > b ? 1 : 0));
    }
}
